import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const PROMPTS = [
  "What are your favourites?",
  "I want your opinion on something!",
];

export const PromptChips = ({ onSelect, disabled }) => {
  return (
    <div
      data-testid="prompt-chips"
      className="flex flex-wrap justify-center sm:justify-start gap-3 w-full"
    >
      {PROMPTS.map((prompt, i) => (
        <motion.button
          key={prompt}
          type="button"
          disabled={disabled}
          data-testid={`prompt-chip-${i}`}
          onClick={() => onSelect(prompt)}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15 + i * 0.08, type: "spring", bounce: 0.3 }}
          whileHover={{ y: -2 }}
          whileTap={{ scale: 0.97 }}
          className="group flex items-center gap-2 rounded-full border border-[#1e293b] bg-[#121b29] px-4 py-2.5 text-sm text-slate-300 hover:text-[#0cb0b5] hover:border-[#0cb0b5] hover:shadow-[0_0_18px_rgba(12,176,181,0.2)] transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0cb0b5]/50 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <span>{prompt}</span>
          <ArrowUpRight className="h-4 w-4 shrink-0 text-slate-600 group-hover:text-[#0cb0b5] transition-colors duration-300" />
        </motion.button>
      ))}
    </div>
  );
};
